import { parseElement as coreParseElement } from "@Core";
import LinkIconTile from "../components/link-icon-tile";
import PillowMenu from "../components/pillow-menu";

const parseElement = (element) => {
	const { id, tag } = element;

	switch (tag) {
		case "extension-link-icon-tile":
			return <LinkIconTile key={id} hasBackground isExtended></LinkIconTile>;
		case "extension-pillow-menu":
			return <PillowMenu key={id} data={element}></PillowMenu>;
		default:
			return coreParseElement(element);
	}
};

export default parseElement;
